import Utils from '@/utils'

export class FantasyRuleResult {
  constructor (pass, msg, id) {
    this.pass = pass
    this.msg = msg
    this.id = id
  }
}

export const RuleResultGood = new FantasyRuleResult(true, 'Good', 200)
export const RuleResultUnknown = new FantasyRuleResult(false, 'Unknown', 501)
export const RuleResultAlreadySelected = new FantasyRuleResult(false, 'Player already selected', 502)

export class BaseFantasyRule {
  constructor (label) {
    this.label = label
    this.teamSpecific = false
    this.range = null
    this.expectedValue = null
    this.showInRules = true
  }

  get lableForMessage () {
    return this.label.toLowerCase()
  }

  get pluralLableForMessage () {
    return `${this.lableForMessage}`
  }

  get hasFulfillmentLabel () {
    return (this.range != null) || (this.expectedValue != null)
  }

  get fulfillmentLabel () {
    if (this.range) {
      const [ lower, upper ] = this.range
      if (lower === upper) {
        return `${lower}`
      }

      if (upper === 0) {
        return `${lower} - ∞`
      }
      return `${lower} - ${upper}`
    } else if (this.expectedValue != null) {
      return `${this.expectedValue}`
    }
    return null
  }

  fulfilled (selectionState, suffix) {
    const value = this.fulfilledValue(selectionState)
    if (value != null) {
      return `${value} ${suffix}`
    }

    return ''
  }

  fulfilledValue (selectionState, playerKey) {
    return null
  }

  labelForFullfilledKey (selectionState, key) {
    return Utils.capitalise(key)
  }

  canSelectError (value, expected, relatedName) {
    return RuleResultGood
  }

  rangeLowerError (value, expected, relatedName) {
    return RuleResultGood
  }

  rangeUpperError (value, expected, relatedName) {
    return RuleResultGood
  }

  canSelect (playerKey, selectionState) {
    return RuleResultGood
  }

  isFulfilled (selectionState) {
    return RuleResultGood
  }
}

export class BaseFantasyRuleRange extends BaseFantasyRule {
  constructor (label, minValue, maxValue) {
    super(label)
    this.range = [minValue, maxValue]
  }

  canSelectError (value, expected, relatedName) {
    return new FantasyRuleResult(false, `${value} ${this.pluralLableForMessage} already selected`, 561)
  }

  rangeLowerError (value, expected, relatedName) {
    return new FantasyRuleResult(false, `Must select atleast ${expected} ${this.pluralLableForMessage}`, 562)
  }

  rangeUpperError (value, expected, relatedName) {
    return new FantasyRuleResult(false, `Only ${expected} ${this.pluralLableForMessage} allowed`, 563)
  }

  fulfilled (selectionState, suffix) {
    let value = this.fulfilledValue(selectionState)

    if (value instanceof Object) {
      let values = []
      Object.keys(value).forEach((key) => {
        const label = this.labelForFullfilledKey(selectionState, key)
        const val = value[key]
        if (val != null) {
          values.push(`${label} (${val})`)
        }
      })

      if (values) {
        value = values.join(', ')
      } else {
        value = null
      }
    }

    if (value != null) {
      return `${value} ${suffix}`
    }

    return ''
  }

  canSelect (playerKey, selectionState) {
    const count = this.fulfilledValue(selectionState, playerKey)
    if (this.range[1] && count >= this.range[1]) {
      return this.canSelectError(count, this.range[1])
    }
    return RuleResultGood
  }

  validate (count, relatedName) {
    if (count === undefined || count === null) {
      count = 0
    }

    const [ lower, upper ] = this.range
    // console.log(`Validate ${this.label}: ${count} / ${lower}-${upper} (${this.relatedName})`)
    if (count < lower) {
      return this.rangeLowerError(count, lower)
    }
    if (upper && count > upper) {
      return this.rangeUpperError(count, upper)
    }
    return RuleResultGood
  }

  isFulfilled (selectionState) {
    const value = this.fulfilledValue(selectionState)
    if (value instanceof Array) {
      for (const count of value) {
        const result = this.validate(count)
        if (!result.pass) {
          return this.validate(count)
        }
      }
    } else if (value instanceof Object) {
      for (const key of Object.keys(value)) {
        const count = value[key]
        const result = this.validate(count, key)
        if (!result.pass) {
          return result
        }
      }
    } else {
      return this.validate(value)
    }

    return RuleResultGood
  }
}
